<template>
    <div>
        <TopBar :navBack="navBackHandler" :title="lbl.customHistory.header" data-cy="component_history_topbar"></TopBar>
        <div class="page" data-cy="container_history_page">
            <div class="pt-7 px-3" data-cy="container_history_list_wrapper">
                <HistoryList
                    ref="history-list"
                    :listConfig="purchaseListConfig"
                    :filterConfig="purchaseFilterListConfig"
                    :modalController="modalController"
                ></HistoryList>
            </div>
        </div>

        <ModalMaster :controller="modalController" data-cy="component_history_modal_master"></ModalMaster>
    </div>
</template>
<script>
import ConfigManager from '@/config/ConfigManager.js';
//component
import TopBar from '@/components/Layout/TopBar/TopBar.vue';
import HistoryList from '../component/HistoryList.vue';
//mixin
// import AuthPageMixin from '@/mixin/AuthPageMixin.js';
import ModalMixin from '@/mixin/ModalMixin.js';
import LocaleMixin from '@/mixin/LocaleMixin';
//service
import {
    PurchaseListConfigBuilder,
    PurchaseFilterConfigBuilder,
} from '@/core/History/config/HistoryConfigModel.js';

// compsable
import usePageClass from "@/composables/PageClassComposable";

export default {
    name: 'History',
    mixins: [ModalMixin, LocaleMixin],
    components: {
        TopBar,
        HistoryList,
    },
    data: function () {
        return {
            purchaseListConfig: null,
            purchaseFilterListConfig: null,
        };
    },
    setup: function () {
        const { pageClass, userLevels } = usePageClass()

        return {
            pageClass,
            userLevels
        }
    },
    created: function () {
        this.setScrollLoadMore();
        this.setupHistoryList();
    },
    mounted: async function () {
        /**@type {import("@/helper/TrackingHelper").TrackingService} */
        const trackingService = this.tracking

        trackingService.screenName("my_history")

        this.loadingModal.show();
        await this.$refs['history-list'].getList();
        this.loadingModal.hide();
    },
    beforeUnmount: function () {
        window.onscroll = null;
    },
    methods: {
        //#region mixin
        onSetupModalCompleted: function () {
            this.initialHistoryModal();
        },
        //#endregion mixin
        setScrollLoadMore: function () {
            window.onscroll = () => {
                // 100 คือระยะก่อนถึงจุดล่างสุดของ page
                var scrollOffSet = 100;
                var pageHeight = Math.max(
                    window.pageYOffset,
                    document.documentElement.scrollTop,
                    document.body.scrollTop
                );
                var bottomOfWindow =
                    pageHeight + window.innerHeight >
                    document.documentElement.offsetHeight - scrollOffSet;
                if (bottomOfWindow) {
                    this.loadMore();
                }
            };
        },
        setupHistoryList: async function () {
            //initial config for api.
            var listConfig = new PurchaseListConfigBuilder()
                .setConfigList(ConfigManager.getHistoryPurchaseList())
                .setTop(25)
                .create();
            this.purchaseListConfig = listConfig;

            //initial filter config for api.
            var filterListConfig = new PurchaseFilterConfigBuilder()
                .create();
            this.purchaseFilterListConfig = filterListConfig;
        },

        loadMore: async function () {
            this.loadingModal.show();
            await this.$refs['history-list'].loadMore();
            this.loadingModal.hide();
        },
        navBackHandler: function () {
            /**@type {import("@/helper/TrackingHelper").TrackingService} */
            const trackingService = this.tracking

            if (this.userLevels.isPlatinum) {
                trackingService.event("my_history_back_platinum", "click_back_platinum", "", null)
            } else {
                trackingService.event("my_history_back_gold", "click_back_gold", "", null)
            }

            this.$nextTick(() => {
                this.$router.replace({
                    name: "privilege"
                })
            })
        }
    },
}
</script>
<style lang="scss" scoped>
</style>
